/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Scholarship_SuffixInputs */

const en_faq_scholarship_suffix = /** @type {(inputs: Faq_Scholarship_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scholarship?`)
};

const es_faq_scholarship_suffix = /** @type {(inputs: Faq_Scholarship_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beca?`)
};

/**
* | output |
* | --- |
* | "Scholarship?" |
*
* @param {Faq_Scholarship_SuffixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_scholarship_suffix = /** @type {((inputs?: Faq_Scholarship_SuffixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Scholarship_SuffixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_scholarship_suffix(inputs)
	return en_faq_scholarship_suffix(inputs)
});